import { FunctionComponent, PropsWithChildren, ReactElement } from 'react';

import { FormControl, InputLabel } from '@mui/material';

import BaseSelectWithCheckboxes from '../../../../../../shared/components/base-select-with-checkboxes/base-select-with-checkboxes';
import { useSelectWithCheckboxesOnChange } from '../../../../../../shared/components/base-select-with-checkboxes/hooks/use-select-with-checkboxes-on-change/use-select-with-checkboxes-on-change.hook';
import { WithOptionsModel } from '../../../../../../shared/components/with-options/models/with-options.model';
import { AppsFilters } from '../../../../models/apps-filters.model';
import { filterAppsByCategories } from '../../../../store/slices/apps.slice';
import { AppsFilterProps } from '../../types/apps-filter-props.type';
import { withAppsFilterValues } from '../with-apps-filter-values';
import withCategoriesOptions from './components/with-categories-options';

const CategoriesDropdown: FunctionComponent<
  AppsFilterProps & WithOptionsModel
> = (
  props: PropsWithChildren<AppsFilterProps & WithOptionsModel>
): ReactElement => {
  const {
    selectedAppFilters: { categories },
    setFieldValue,
    options,
  } = props;

  const selectedCategoriesMapped = options
    .filter(item => categories?.includes(item.id))
    .map(item => item.id);

  const onChange = useSelectWithCheckboxesOnChange<AppsFilters>(
    'categories',
    setFieldValue,
    filterAppsByCategories
  );

  return (
    <FormControl
      classes={{
        root: 'form-control-main',
      }}
      key="apps-categories"
      variant="filled"
    >
      <InputLabel id="multiple-checkbox-label-platforms">Categories</InputLabel>

      <BaseSelectWithCheckboxes
        id="categories"
        name="categories"
        onChange={onChange}
        selectOptions={options}
        clearMultiSelectFilterAction={filterAppsByCategories}
        value={selectedCategoriesMapped ?? []}
      />
    </FormControl>
  );
};

export default withAppsFilterValues(withCategoriesOptions(CategoriesDropdown));
